import styled from 'styled-components';

const AuthInnerContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;

  display: flex;
  flex-direction: column;

  gap: 20px;
  padding: 20px;

  box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;

  @media only screen and (min-width: 768px) {
    width: 40%;
  }
`;

export default AuthInnerContainer;
